var _rect, _path, _path2, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmarkInCircule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.112 23.652H31.83a.87.87 0 00-.708.364l-4.299 5.961-1.947-2.702a.874.874 0 00-.708-.363h-1.282c-.178 0-.282.202-.178.347l3.407 4.725a.87.87 0 001.414 0L33.287 24a.218.218 0 00-.175-.348z",
    fill: "#597EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.75c-6.765 0-12.25 5.485-12.25 12.25S21.235 40.25 28 40.25 40.25 34.765 40.25 28 34.765 15.75 28 15.75zm0 22.422c-5.616 0-10.172-4.556-10.172-10.172 0-5.616 4.556-10.172 10.172-10.172 5.616 0 10.172 4.556 10.172 10.172 0 5.616-4.556 10.172-10.172 10.172z",
    fill: "#597EF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 26,
    stroke: "#F0F5FF",
    strokeWidth: 4
  })));
}

export default __webpack_public_path__ + "./fonts/checkmark-in-circule.e33b02883b7d3de95b65493ae9f801df.svg";
export { SvgCheckmarkInCircule as ReactComponent };